import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { DateRangePicker } from "@components/date-range-picker/date-range-picker";
/**
 * Displays the analytics date range filter and forwards accepted selections.
 */
export function AnalyticsSearchFilter(t0) {
  const $ = _c(4);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flex: 1,
      display: "flex",
      justifyContent: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange || $[2] !== value) {
    t2 = <Stack data-testid="analytics-search-filter" sx={t1}><DateRangePicker value={value} onAccept={onChange} /></Stack>;
    $[1] = onChange;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}